"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getIsLoadingActivityLog = exports.getHasNextActivityLogPage = exports.getHasActivityLogFetchSuccess = exports.getHasActivityLogFetchErrored = exports.getActivityLogState = exports.getActivityLogPagination = exports.getActivityLog = exports.fetchActivityLogAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _fetchHelpers = require("../fetchHelpers");
var _sheets = require("./sheets");
var _documents = require("./documents");
var _PlacementActivityType = require("../../../../sdk/types/PlacementActivityType");
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  activityLog: [],
  pendingFetchRequestId: undefined
};
const activityLogCollectionSlice = (0, _toolkit.createSlice)({
  name: "activityLog",
  initialState,
  reducers: {
    logFetchStart: (state, action) => {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
      state.pendingFetchRequestId = action.payload.requestId;
    },
    logFetchSuccess: (state, action) => {
      const {
        requestId,
        response
      } = action.payload;
      // ignore any payloads that aren't part of the most recently called request
      if (requestId !== state.pendingFetchRequestId) {
        return;
      }
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      if (response.pagination.offset) {
        state.activityLog.push(...response.results);
      } else {
        state.activityLog = response.results;
      }
      state.pagination = response.pagination;
      state.pendingFetchRequestId = undefined;
    },
    logFetchFailure: (state, action) => {
      const {
        requestId
      } = action.payload;
      // ignore any payloads that aren't part of the most recently called request
      if (requestId !== state.pendingFetchRequestId) {
        return;
      }
      state.pendingFetchRequestId = undefined;
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
    }
  }
});
const reducer = exports.reducer = activityLogCollectionSlice.reducer;
const STATE_KEY = exports.STATE_KEY = activityLogCollectionSlice.name;
const getActivityLogState = state => state[STATE_KEY];
exports.getActivityLogState = getActivityLogState;
const getIsLoadingActivityLog = exports.getIsLoadingActivityLog = (0, _toolkit.createSelector)(getActivityLogState, _fetchHelpers.isLoading);
const getHasActivityLogFetchErrored = exports.getHasActivityLogFetchErrored = (0, _toolkit.createSelector)(getActivityLogState, _fetchHelpers.isErrored);
const getHasActivityLogFetchSuccess = exports.getHasActivityLogFetchSuccess = (0, _toolkit.createSelector)(getActivityLogState, _fetchHelpers.isSuccess);
const getActivityLogPagination = exports.getActivityLogPagination = (0, _toolkit.createSelector)(getActivityLogState, state => state.pagination);
const getHasNextActivityLogPage = exports.getHasNextActivityLogPage = (0, _toolkit.createSelector)(getActivityLogState, state => state.pagination ? state.activityLog.length < state.pagination.totalResults : true);
const getActivityLog = exports.getActivityLog = (0, _toolkit.createSelector)(getActivityLogState, state => state.activityLog);
const {
  logFetchStart,
  logFetchFailure,
  logFetchSuccess
} = activityLogCollectionSlice.actions;
const getDocumentAndSheetIds = activityBlocks => {
  const sheetIds = new Set();
  const documentIds = new Set();
  const documentUrns = new Set();
  activityBlocks.forEach(activityChange => {
    activityChange.changes.forEach(change => {
      const {
        placement,
        changed_target_urn
      } = change.object;
      if (placement) {
        const {
          id,
          idType,
          surfaceType
        } = placement;
        if (surfaceType === _PlacementActivityType.SurfaceType.Sheet) {
          sheetIds.add(id);
        }
        if (surfaceType === _PlacementActivityType.SurfaceType.Document && (!idType || idType === _PlacementActivityType.IdType.DocumentId)) {
          documentIds.add(id);
        }
        if (surfaceType === _PlacementActivityType.SurfaceType.Document && idType === _PlacementActivityType.IdType.LineageUrn) {
          documentUrns.add(id);
        }
      }
      // todo: remove this if block, when all activity will be of type "placement". This should happen sometime in Jan 2023
      if (changed_target_urn) {
        const {
          before,
          after
        } = changed_target_urn;
        if (!!before) {
          documentUrns.add(before);
        }
        if (!!after) {
          documentUrns.add(after);
        }
      }
    });
  });
  return {
    sheetIds: Array.from(sheetIds),
    documentIds: Array.from(documentIds),
    documentUrns: Array.from(documentUrns)
  };
};
const fetchActivityLogAction = function (issueId) {
  let pagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let customFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    placementActivities: true,
    deletedIssueActivity: false,
    restoredIssueActivity: false,
    snapshotIssueActivity: false,
    attachmentIssueActivity: false
  };
  return async (dispatch, getState, _ref) => {
    let {
      sdk
    } = _ref;
    const requestId = (0, _uuid.v4)();
    const isInfiniteScroll = !!pagination.offset;
    dispatch(logFetchStart({
      requestId
    }));
    try {
      const response = await sdk.IssueActivityLogApi.getAll(issueId, pagination, customFilters);
      const {
        results
      } = response;
      const {
        sheetIds,
        documentIds,
        documentUrns
      } = getDocumentAndSheetIds(results);
      await dispatch((0, _sheets.fetchSheets)({
        sheetIds,
        useCache: true
      }));
      await dispatch((0, _documents.fetchDocumentsByDocumentVersionIds)({
        documentVersionIds: documentIds,
        useCache: true
      }));
      await dispatch((0, _documents.fetchDocumentsByUrns)({
        documentUrns,
        useCache: true
      }));
      dispatch(logFetchSuccess({
        response,
        requestId
      }));
      return response;
    } catch (err) {
      if (!isInfiniteScroll) {
        dispatch(logFetchFailure({
          requestId
        }));
      }
      return null;
    }
  };
};
exports.fetchActivityLogAction = fetchActivityLogAction;
//# sourceMappingURL=issueActivityLog.js.map